<app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
<div id="flip-external-report-screen">
  <div class="dashboard-side-card-container">
    <app-client-information
      [attributes]="_clientInformationAttributes"
      [isVertialOrientation]="true"
      [title]="_clientInformationTitle"
      [urlDisplayText]="_clientInformationDisplayText"
      [url]="_clientInformationUrl"
      id="client-information"
      subtitle=""
    />
  </div>
  <app-sub-menu
    (navigateBackClick)="routerLinkClicked()"
    [clientId]="_clientId"
    [flipHasAccess]="_hasAccess.flipHasAccess"
    [reddiHasAccess]="_hasAccess.reddiHasAccess"
    [showBackButton]="true"
    [slatHasAccess]="_hasAccess.slatHasAccess"
    [totalReviews]="_totalReviews"
  />
  <div id="content-page-1">
    <div class="flip-external-report" id="report-content">
      <div class="external-report-heading">
        <div class="header-text">
          {{ 'Progress Report' | translate }}: Functional Listening
          Index-Paediatric®
        </div>
        <div class="logo">
          <img [src]="path" alt="FLI-P logo" class="flip-logo" />
        </div>
      </div>
      <div class="client-details">
        <strong>{{ 'Date' | translate }}:</strong>
        {{ _todayDate | date: 'dd/MM/yyyy' }}
      </div>
      <div class="client-details">
        <strong>{{ 'Name' | translate }}:</strong> {{ _title }}
        <strong>{{ 'Age' | translate }}:</strong> {{ _age }}
        <strong>{{ 'Date of Birth' | translate }}:</strong> {{ _dob }}
      </div>
      <div class="assessment-info">
        <p>{{ _title }}'s {{ 'Flip Report Comment' | translate }}</p>
        <p>
          {{ _title }}'s {{ 'Flip Report Comment 2' | translate }}
          {{ _title }}'s {{ 'Flip Report Comment 3' | translate }}
          {{ _title }}'s {{ 'Flip Report Comment 4' | translate }}
          {{ _score }}/64 {{ 'items' | translate }}
        </p>
      </div>

      <div class="graph-section">
        <div class="flip-report-graph">
          <app-flip-overview-graph
            [clientId]="_clientId"
          ></app-flip-overview-graph>
        </div>
      </div>
      <div class="contact-info-footer">
        <div class="clinician-info">
          <div>
            <strong>{{ 'Clinician name' | translate }}:</strong
            >&NonBreakingSpace; {{ _name }}
          </div>
          <p>
            <strong>{{ 'Title Role' | translate }}:</strong> &NonBreakingSpace;
            {{ _role }}
          </p>
        </div>
        <div class="report-hearhub-logo">
          <app-hearhub-logo
            [inverted]="false"
            class="login-brand-logo"
          ></app-hearhub-logo>
        </div>
      </div>
      <div class="page-number">{{ 'Page' | translate }} 1</div>
    </div>
  </div>
  <div *ngIf="shouldShowContentPage2" id="content-page-2">
    <div class="flip-external-report" id="report-content">
      <div class="flip-report-page2-content">
        <div class="external-report-page2-header">
          <div class="logo">
            <app-flip-logo />
          </div>
        </div>
        <div class="client-details">
          <strong>{{ 'Name' | translate }}:</strong> {{ _title }}
          <strong>{{ 'Age' | translate }}:</strong> {{ _age }}
          <strong>{{ 'Date of Birth' | translate }}:</strong> {{ _dob }}
        </div>
        <div class="assessment-info">
          {{ 'As determined using the' | translate }} Functional Listening
          Index-Paediatric® (FLI-P®), {{ _title }}'s
          {{ 'recent and next listening skills are listed' | translate }}
          {{ 'below' | translate }}
        </div>
        <div class="assessment">
          <div class="assessment-headline">
            {{ 'Recent listening skills gained' | translate }}
          </div>
          <div *ngFor="let group of _collapsibleItems">
            <div class="assessment-header">{{ group.header }}</div>
            <div *ngFor="let item of group.subItems">
              <app-flip-item-summary
                [buttonType]="GetButtonType(item.score)"
                [description]="item.content"
                [number]="item.number"
                [score]="item.score"
                [variant]="'score-text'"
              >
              </app-flip-item-summary>
            </div>
          </div>
        </div>
        <div class="assessment">
          <div class="assessment-headline">
            {{ 'Next listening skills to develop' | translate }}
          </div>
          <!-- Inside flip-external-report.component.html -->
          <div *ngFor="let group of _collapsibleItemsRarely">
            <div class="assessment-header">{{ group.header }}</div>
            <div *ngFor="let item of group.subItems">
              <app-flip-item-summary
                [buttonType]="GetButtonType(item.score)"
                [description]="item.content"
                [number]="item.number"
                [score]="item.score"
                [variant]="'score-text'"
              >
              </app-flip-item-summary>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-info-footer">
        <div class="clinician-info">
          <div>
            <strong>Clinician name:</strong> &NonBreakingSpace; {{ _name }}
          </div>
          <p><strong>Title/Role:</strong>&NonBreakingSpace; {{ _role }}</p>
        </div>

        <div class="report-hearhub-logo">
          <app-hearhub-logo
            [inverted]="false"
            class="login-brand-logo"
          ></app-hearhub-logo>
        </div>
      </div>
      <div class="page-number">{{ 'Page' | translate }} 2</div>
    </div>
  </div>
  <div class="button-section">
    <app-action-button
      (onClick)="generateReportPDF()"
      color="primary"
      id="print-button"
      kind="filled"
      size="large"
      type="button"
      >{{ 'Download report' | translate }}
    </app-action-button>
  </div>
</div>
